import TechStack from '../sections/TechStack';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';

const TechStackPage = () => (
  <>
    <SEO
      title="Our Tech Stack | Farwings Tech Solutions"
      description="Explore the cutting-edge technologies, frameworks, and databases we use to engineer scalable custom software, web applications, and mobile apps."
      breadcrumbs={[
        { name: 'Home', path: '/' },
        { name: 'Tech stack', path: '/tech-stack' },
      ]}
    />
    <PageHero title="Tech stack">
      React, Next.js, Flutter, Node.js and the cloud tools behind everything we ship, picked so your product
      stays fast, secure and easy to grow.
    </PageHero>
    <TechStack full hideHead />
  </>
);

export default TechStackPage;
